import { render } from "./BannerContato.vue?vue&type=template&id=cc70b37e&scoped=true&lang=pug"
const script = {}

import "./BannerContato.vue?vue&type=style&index=0&id=cc70b37e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc70b37e"]])

export default __exports__